import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../Account/account.slice'
import { Formik } from 'formik'
import { object as YupObject, string as YupString } from 'yup'
import classNames from 'classnames'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { setSelectedAdditionalDataModal } from '../Reports/reports.slice'
import { deleteDocument } from '../Documents/documents.asyncActions'

const DeleteDocumentModal = () => {
	const { resetFFLDetails } = actions
	const dispatch = useDispatch()
	const resetModal = () => {
		dispatch(setSelectedAdditionalDataModal(null))
		dispatch(resetFFLDetails())
	}

	useEffect(() => {
		dispatch(showModal())
	}, [dispatch])
	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const validationSchema = YupObject().shape({
		documentId: YupString().required('Document Id is Required'),
	})
	const initialValues = {
		documentId: '',
	}
	return (
		<Formik
			enableReinitialize={true}
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values, { setSubmitting, resetForm }) => {
				dispatch(deleteDocument(values.documentId)).then((data) => {
					resetForm()
					setSubmitting(false)
					handleClose()
				})
			}}
		>
			{({
				values,
				errors,
				touched,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
			}) => {
				const footer = (
					<>
						<Button
							className='h-50 w-190'
							variant='outline'
							onClick={handleClose}
						>
							Cancel
						</Button>
						<Button
							className='h-50 w-190'
							onClick={handleSubmit}
							disabled={isSubmitting}
						>
							<BusyIndicator region={REGIONS.DELETE_DOCUMENT}>
								Delete Document
							</BusyIndicator>
						</Button>
					</>
				)
				return (
					<>
						<Modal
							footer={footer}
							reset={resetModal}
							size='md'
							title='Please Provide the Id of the document you want to delete'
						>
							<div className='f-14'>
								<div className='form-group'>
									<Label className='font-weight-normal'>{`Document Id`}</Label>
									<Input
										type='text'
										name='documentId'
										value={values.documentId}
										onChange={handleChange}
										onBlur={handleBlur}
										className={classNames({
											error: touched.documentId && errors.documentId,
										})}
									/>
									{touched.documentId && errors.documentId && (
										<div className='error-message'>{errors.documentId}</div>
									)}
								</div>
							</div>
						</Modal>
					</>
				)
			}}
		</Formik>
	)
}
export default DeleteDocumentModal
